import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";
import SchemaOrg from "@/components/feature/SchemaOrg";

export default function About() {
  const title = "关于我们 - 屁屁影院";
  const desc = "屁屁影院致力于为用户提供海量高清影视资源免费在线观看服务。了解屁屁影院的品牌故事、用户口碑及联系方式，享受极致的观影体验。";
  const keywords = "屁屁影院,关于屁屁影院,屁屁影院品牌介绍,屁屁影院联系方式,在线影院免费看片";

  return (
    <>
      <SEOHead
        title={title}
        description={desc}
        keywords={keywords}
        canonicalUrl="https://www.pipicinema.com/about"
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: "https://www.pipicinema.com/" },
            { "@type": "ListItem", position: 2, name: "关于我们" },
          ],
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "屁屁影院",
          url: "https://www.pipicinema.com",
          description: "海量高清影视资源免费在线观看平台",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+86-400-888-8888",
            contactType: "customer service",
            email: "contact@pipicinema.com",
          },
          address: {
            "@type": "PostalAddress",
            addressLocality: "北京市",
            addressRegion: "朝阳区",
            addressCountry: "中国",
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            {
              "@type": "Question",
              name: "屁屁影院需要注册才能观看吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "不需要。屁屁影院所有影视资源均可免费在线观看，无需注册登录，零门槛畅享海量高清影视内容。",
              },
            },
            {
              "@type": "Question",
              name: "屁屁影院支持哪些设备观看？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "屁屁影院支持电脑、平板、手机等多种终端设备流畅播放，自适应屏幕尺寸，无论您使用什么设备都能获得良好的观影体验。",
              },
            },
            {
              "@type": "Question",
              name: "屁屁影院的影视资源多久更新一次？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "屁屁影院的影视资源每日更新，第一时间上线最新电影、热门电视剧和综艺节目，确保用户能够及时观看到最新的影视内容。",
              },
            },
            {
              "@type": "Question",
              name: "屁屁影院的视频画质如何？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "屁屁影院提供高清画质播放，支持1080P超清分辨率，为您带来极致的视觉享受和沉浸式观影体验。",
              },
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="max-w-[1400px] mx-auto px-4 md:px-6 pt-24 pb-14">
          <Breadcrumb
            items={[
              { label: "首页", path: "/" },
              { label: "关于我们" },
            ]}
          />

          {/* Hero */}
          <section className="relative w-full h-[280px] md:h-[380px] rounded-2xl overflow-hidden mb-14">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20warm%20ambient%20lighting%20comfortable%20red%20seats%20and%20large%20screen%20cinematic%20atmosphere%20professional%20photography%20high%20quality&width=1920&height=600&seq=about-hero-pipi&orientation=landscape"
              alt="屁屁影院品牌介绍"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>
            <div className="absolute inset-0 flex items-center justify-center text-center">
              <div>
                <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading">
                  关于屁屁影院
                </h1>
                <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto px-4">
                  致力于为每一位影视爱好者提供最优质的免费观影体验
                </p>
              </div>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="mb-14" id="intro">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 font-heading">
              品牌介绍
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  <strong className="text-foreground-950">屁屁影院</strong>成立于
                  <strong className="text-foreground-950">2023年</strong>，是一家专注于提供
                  <strong className="text-foreground-950">海量高清影视资源免费在线观看</strong>的互联网平台。自上线以来，我们始终坚持以用户体验为核心，致力于打造一个内容丰富、界面简洁、播放流畅的一站式影视平台。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  平台涵盖<strong className="text-foreground-950">电影、电视剧、综艺、动漫</strong>等多种类型，资源总量超过
                  <strong className="text-foreground-950">10万部</strong>，且每日持续更新。我们与国内外多家正版内容提供商建立了深度合作关系，确保为用户提供最新、最全面的影视内容。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  屁屁影院坚持
                  <strong className="text-foreground-950">无需注册、免费观看</strong>的理念，让每一位用户都能零门槛享受高品质的观影服务。同时，我们不断优化技术架构，支持
                  <strong className="text-foreground-950">1080P超清画质</strong>和多终端自适应播放，无论是在电脑、平板还是手机上，都能获得流畅舒适的观影体验。
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-background-100 p-6 rounded-xl text-center">
                  <div className="text-3xl font-bold text-accent-600 mb-2 font-heading">10万+</div>
                  <p className="text-sm text-foreground-600">影视资源总量</p>
                </div>
                <div className="bg-background-100 p-6 rounded-xl text-center">
                  <div className="text-3xl font-bold text-accent-600 mb-2 font-heading">500万+</div>
                  <p className="text-sm text-foreground-600">日均活跃用户</p>
                </div>
                <div className="bg-background-100 p-6 rounded-xl text-center">
                  <div className="text-3xl font-bold text-accent-600 mb-2 font-heading">99.9%</div>
                  <p className="text-sm text-foreground-600">播放成功率</p>
                </div>
                <div className="bg-background-100 p-6 rounded-xl text-center">
                  <div className="text-3xl font-bold text-accent-600 mb-2 font-heading">24/7</div>
                  <p className="text-sm text-foreground-600">内容更新保障</p>
                </div>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="mb-14" id="reputation">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 font-heading">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: "王先生",
                  role: "资深影迷",
                  comment: "屁屁影院的资源真的是太全了，我想看的电影基本都能找到，而且画质非常好，加载速度也很快，强烈推荐给喜欢看电影的朋友们！",
                  rating: 5,
                },
                {
                  name: "李女士",
                  role: "追剧达人",
                  comment: "每天都在屁屁影院追剧，更新速度特别快，热播剧集第一时间就能看到。最方便的是不用注册，打开就能看，体验超棒！",
                  rating: 5,
                },
                {
                  name: "张同学",
                  role: "动漫爱好者",
                  comment: "作为动漫粉，屁屁影院的动漫资源让我非常满意，从国产动漫到日本动漫应有尽有，清晰度也很高，看番的最佳选择！",
                  rating: 5,
                },
                {
                  name: "刘先生",
                  role: "综艺迷",
                  comment: "综艺节目更新非常及时，每周五晚必看屁屁影院的最新综艺。多端支持功能也很实用，通勤路上用手机也能流畅观看。",
                  rating: 4,
                },
                {
                  name: "陈女士",
                  role: "家庭用户",
                  comment: "全家人都在用屁屁影院，老人看电视剧，孩子看动漫，我和老公看电影，一个平台满足全家人需求，而且完全免费，太赞了！",
                  rating: 5,
                },
                {
                  name: "赵先生",
                  role: "技术达人",
                  comment: "屁屁影院的技术体验做得很好，无论是网页端还是手机端都很流畅。搜索功能精准，分类清晰，找片效率很高。",
                  rating: 5,
                },
              ].map((review, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200 rounded-xl p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-sm ${j < review.rating ? "ri-star-fill text-amber-400" : "ri-star-line text-foreground-300"}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center text-accent-700 text-sm font-bold">
                      {review.name[0]}
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">
                        {review.name}
                      </p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 font-heading">
              常见问题
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                {
                  q: "屁屁影院需要注册才能观看吗？",
                  a: "不需要。屁屁影院所有影视资源均可免费在线观看，无需注册登录，零门槛畅享海量高清影视内容。",
                },
                {
                  q: "屁屁影院支持哪些设备观看？",
                  a: "屁屁影院支持电脑、平板、手机等多种终端设备流畅播放，自适应屏幕尺寸，无论您使用什么设备都能获得良好的观影体验。",
                },
                {
                  q: "屁屁影院的影视资源多久更新一次？",
                  a: "屁屁影院的影视资源每日更新，第一时间上线最新电影、热门电视剧和综艺节目，确保用户能够及时观看到最新的影视内容。",
                },
                {
                  q: "屁屁影院的视频画质如何？",
                  a: "屁屁影院提供高清画质播放，支持1080P超清分辨率，为您带来极致的视觉享受和沉浸式观影体验。",
                },
                {
                  q: "屁屁影院的资源是否正版？",
                  a: "屁屁影院与多家正版内容提供商合作，所有资源均获得合法授权，用户可放心观看。",
                },
                {
                  q: "观看过程中遇到问题怎么办？",
                  a: "您可以通过页面上显示的联系方式与我们的客服团队取得联系，我们将第一时间为您解决问题。",
                },
              ].map((faq, i) => (
                <div
                  key={i}
                  className="bg-background-50 border border-background-200 rounded-xl p-5"
                >
                  <h4 className="text-base font-semibold text-foreground-950 mb-2 font-heading">
                    <i className="ri-question-line text-accent-500 mr-2"></i>
                    {faq.q}
                  </h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section id="contact">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 font-heading">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 border border-background-200 rounded-xl p-6 flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <div>
                  <h4 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                    电子邮箱
                  </h4>
                  <p className="text-sm text-foreground-600">contact@pipicinema.com</p>
                  <p className="text-xs text-foreground-500 mt-1">商务合作、版权咨询</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-xl p-6 flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <div>
                  <h4 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                    客服电话
                  </h4>
                  <p className="text-sm text-foreground-600">400-888-8888</p>
                  <p className="text-xs text-foreground-500 mt-1">周一至周日 9:00 - 21:00</p>
                </div>
              </div>
              <div className="bg-background-50 border border-background-200 rounded-xl p-6 flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <h4 className="text-base font-semibold text-foreground-950 mb-1 font-heading">
                    公司地址
                  </h4>
                  <p className="text-sm text-foreground-600">北京市朝阳区建国路88号</p>
                  <p className="text-xs text-foreground-500 mt-1">屁屁科技有限公司</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}